<template>
  <div class="ma-5 ml-3 site_content">
    <div class="flex s-bt">
      <comboFarm
      @fromFarm="farmInfo"
      />
      <img :src="icon_raw" class="raw_icon" @click="RawRouter(farmData)"/>
    </div>


    <div class="content_container mt-5">
      <div class="spinner mb-10 mt-5" v-if="loading"></div>

      <div class="flex flex-center" v-else>
        <!-- <div class="total_info mr-3">
          <div class="box_title">발정의심</div>
          <div class="box_info">
            <span class="box_title">
              <span></span>
              <span>/</span> 
              <span class="font-m"> {{ items.length }} </span>
            </span>
          </div>
        </div>

        <div class="total_info mr-3">
          <div class="box_title">발정확정</div>
          <div class="box_info">
            <span class="box_title">
              <span></span>
              <span>/</span> 
              <span class="font-m"> {{ items.length }} </span>
            </span>
          </div>
        </div> -->

        <div class="total_info">
          <div class="box_title">금일 신규 알람</div>
          <div class="box_info">
            <span class="box_title">
              <span class="font-m mr-1">{{ alertCount }}</span>
              <span>/</span> 
              <span class="font-m"> {{ items.length }} </span>
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3 detector_container">
      
      <v-text-field dense style="width:250px" class="shrink"
        clearable
        variant="outlined"
        single-line
        v-model="search"
        append-icon="mdi-magnify"
        placeholder="개체식별명으로 검색하세요."
        hide-details
      ></v-text-field>
      <div class="spinner mb-10 mt-5" v-if="loading"></div>

      <div class="table_content mt-3" v-else>
        <div class="table_layout">
          <v-data-table dense
              fixed-header
              :footer-props="{
                itemsPerPageOptions:[-1]
              }"
              :items-per-page="-1" 
              :headers="headers"
              :items="items"
              no-data-text="측정된 자료가 없습니다."
              class="table_content"
              height="50vh"
              item-key="mesuredt"
              single-select
              hide-default-footer
              :sort-by= "['mesuredt']"
              :sort-desc= "[true]"
              :search="search"
            >
            <template v-slot:item="{ item }">
              <tr>
                <td class="table_line" @click="toggleSort('mesuredt')">{{ item.mesuredt }}</td>
                <td class="table_line">{{ item.mesureval01 }}</td>
                <td class="table_line">{{ item.mesureval02 }}</td>
                <td class="table_line">{{ item.mesureval03 }}</td>
                <td class="table_line">{{ item.mesureval04 }}</td>
                <td class="table_line">{{ item.mesureval05 }}</td>
                <td class="table_line">{{ item.mesureval06 }}</td>
                <td class="table_line">{{ item.mesureval07 }}</td>
                <td class="table_line">{{ item.mesureval08 }}</td>
                <!-- <td class="table_line">{{ item.mesureval09 }}</td> -->
                <td class="table_line detail" @click="Dialog(item)">📶</td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>

    <!--상세정보-->
    <estrusDialog
      :visible="detailDialog"
      :farm="farmData"
      :cow="selectedCow"
      @close="detailDialog = false">
    </estrusDialog>

  </div>
</template>

<script>
import Apis from '@/api/apis';
import dateUtil from "@/utils/custom/dateProperty.js";

import comboFarm from "@/components/combo/farm.vue";
import estrusDialog from "./packCompo/estrusDialog.vue";

export default {
  name: 'Estrusdetector',
  components:{
    comboFarm,
    estrusDialog
  },
  async created() {
    Apis.getIpClient((res) => {
      // console.log(res);  
      let client = res
      Apis.pageCount({ //페이지뷰 카운터
        page_name: `${client.city}/${client.country}/${client.region}/${client.loc}/${client.org}/${client.postal}/${client.timezone}`,
        url: this.$route.path,
        ip: client.ip,
        division: "cloud",
      },() => {  // 정상처리
        // console.log("pageCount 호출",res);
      }).catch( (err) => {  // 개별 API 오류 처리 예제
        console.log("pageCount 호출 오류",err);
      });
    }).catch( (err) => {  // API 오류 처리
        console.log("getIpClient 호출 오류",err)
    }) 


  },
  computed: {
    alertCount() {
      if (!this.items || this.items.length === 0) return 0;
      const today = dateUtil.format(new Date(), "yyyy-MM-dd");
      return this.items.filter(item => item.mesureval08 && item.mesureval08.includes(today)).length;
    }
  },
  data(){
    return {
      farmData: { company: {}, farm: {} },
      icon_raw: require("@/assets/pack/raw_data.svg"),

      search:'',

      items:[],

      headers: [
        { text: '측정시간', align:'center',sortable: true, value: 'mesuredt' },
        { text: '개체식별번호',align:'center',sortable: false, value: 'mesureval01' },
        { text: '운동량(회/분)', align:'center',sortable: false,value: 'mesureval02' },
        { text: '반추량(회/분)', align:'center',sortable: false,value: 'mesureval03' },
        { text: '체온(℃ )', align:'center',sortable: false,value: 'mesureval04' },
        { text: 'PH', align:'center',sortable: false,value: 'mesureval05' },
        { text: '발정상태', align:'center',sortable: false, value: 'mesureval06' },
        { text: '건강상태', align:'center',sortable: false, value: 'mesureval07' },
        { text: '알람시간', align:'center',sortable: false, value: 'mesureval08' },
        // { text: '동작상태', value: 'mesureval09' },
        { text: '개체상세', align:'center', sortable: false, value: '' },

      ],

      sortBy: {
        type: String,
        default: "mesuredt",
      },
      sortDesc: {
        type: Boolean,
        default: true,
      },

      //dialog

      loading:false,
      detailDialog: false,
      selectedCow: null,
      
    }
  },
  methods:{
    toggleSort(column) {
      if (this.sortBy === column) {
        this.sortDesc = !this.sortDesc;
      } else {
        this.sortBy = column;
        this.sortDesc = false;
      }
    },
    async farmInfo(data){
      this.farmData = data;

      this.refresh();
    },
    RawRouter(farmData){
      // console.log(farmData)
      // this.$router.push({
      //   name: "rawData",
      //   params: { 
      //     farm:{code: farmData.farm.code, name: farmData.farm.name},
      //     typeCode: "BI01"
      //     // type:{code:'BI01', name:'발정탐지기'}
      //    }
      // });
      sessionStorage.setItem("pack_farm", JSON.stringify({
        farm: { code: farmData.farm.code, name: farmData.farm.name }
      }));

      this.$router.push({
        name: "rawData",
        params: { 
          typeCode: "BI01" 
        }
      });
    },
    refresh(){
      let cdate = new Date();

      this.loading=true;
      
      Apis.listBI01dataOfPackage({
        farm_cd : this.farmData.farm.code,
        stand_date : dateUtil.format(cdate, "yyyy-MM-dd"),
        months : 1
      },(res) => {  
        if (res.result) {
        this.items = res.data.values;

        this.$store.commit("resMessage",res.message);
      } else {
          alert(res.message);
        }
        this.loading = false;
      }).catch( (err) => {  // API 오류 처리
          console.log("listBI01dataOfPackage API 호출 오류",err)
          this.loading = false;
      })
    },
    Dialog(item){
      this.selectedCow = item;
      this.detailDialog = true;
    }

  }
}
</script>

<style lang="scss" scoped>
@import '../../style/base.scss';
.total_info{
  box-sizing: border-box;
  padding:10px;
  background: #FFFFFF;
  border-left: 7px solid $main-color;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  width:180px;
  height:80px;
}
.box_title{
  color:#6E6E6E;
  font-size:0.95rem;
  font-weight:600;
  letter-spacing: -0.75px;
  text-align: center;
}
.box_info{
  color:$main-color;
  font-weight:550;
  font-size:1.7rem;
  text-align: center;
  // margin-top:3px;
}
.detector_container{
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  background: #FFFFFF;
  padding:20px;

}
.table_layout{
  margin-top:10px;
  padding:0 !important;
}
.table_content{
  height:50vh;
  min-height:250px;
}
.table_line{
  text-align: center;
}
.font-m{
  font-size:20px;
  letter-spacing: -1px;
}
.detail{
  cursor: pointer;
}
</style>